import { DER_SPIEGEL, DIE_WELT, HANDELSBLATT, SWR_PRESS } from 'assets/images/images';

export const TITLE_LINE_HEIGHT = 1.55;

export const bodyFontSize = (mobile?: boolean) => {
  return mobile ? 16 : 18;
};

export const highlightedBodyFontSize = (mobile?: boolean) => {
  return mobile ? 18 : 20;
};

export const headlineFontSize = (mobile?: boolean) => {
  return mobile ? 26 : 38;
};

export const mediumFontSize = (mobile?: boolean) => {
  return mobile ? 20 : 26;
};

export const knownFromList = [
  { src: DER_SPIEGEL, alt: 'Der Spiegel' },
  { src: DIE_WELT, alt: 'Die Welt' },
  { src: HANDELSBLATT, alt: 'Handelsblatt' },
  { src: SWR_PRESS, alt: 'SWR' },
];
